<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card header-tag="header" footer-tag="footer">
                    <div slot="header">
                        <strong> TAT Upload</strong> 
                    </div>

                    <b-row>
                        <b-col md="12" >                
                            <div>
                                <div>
                                    <b-row >
                                        <b-col md="7">
                                            <b-row>
                                                <b-col md="3">
                                                    <label><b>Upload CSV File</b></label>&nbsp;<span style="color: red;">*</span>
                                                </b-col>
                                                <b-col md="8">
                                                    <b-form-group>
                                                        <b-form-file type="file" v-model="file"
                                                        :state="Boolean(file)" @change="selectcsvFiletoUpload($event)"
                                                        placeholder="Upload CSV File" accept=".csv"
                                                        ></b-form-file>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col md="5">
                                            <b-row>
                                                <b-col md="2">
                                                    <b-button variant="primary" :pressed.sync="myToggle" @click="uploadcsv()">Submit</b-button>
                                                </b-col>
                                                <b-col md="2">
                                                    <b-button variant="danger"  @click="clearcsv()">Clear</b-button>
                                                </b-col>
                                                <b-col md="4">
                                                    <label for="name" ><a
                                                        href="img/tat_upload.csv"
                                                        download="tat_upload.csv"
                                                        target="_blank"
                                                        >Download Sample CSV</a
                                                        >
                                                    </label>
                                                </b-col>
                                                
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </div>

                                <div class="route-border">
                                    <b-table  show-empty responsive :busy="isBusy"   :items="CountDetailsList"  
                                                        :fields="CountDetailsfields" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" class="routetable" >                                            
                                        <div slot="table-busy" class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                        </div>
                                        <template slot="successfulcount" slot-scope="row">
                                            <a href="#" @click="handleColumnClick('success')">{{ row.item.successfulcount }} </a>
                                        </template>
                                        <template slot="failurecount" slot-scope="row">
                                            <a href="#" @click="handleColumnClick('fail')">{{ row.item.failurecount }} </a>
                                        </template>
                                        
                                    </b-table>
                                </div>

                                

                <!-- //Route management table -->
                                <div id="successfulcard" style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);" class="mb-1">
                                    <!-- display:none; -->
                            <b-tabs content-class="mt-3" lazy justified >
                                <b-tab title="Total Records" show >
                                    <!-- Total Records Start-->
                                    <b-row>
                                    <b-col sm="12" class="text-right  margin-bottom =-13px;" >
                                        <b>Total Records :<span style="color:red;"> {{ routertotalRows }}</span></b>   &nbsp;&nbsp;&nbsp;
                                    </b-col>

                                    <b-col sm="12" style="overflow:auto;">  
                                    <strong>Total Record</strong>
                                    <b-table  show-empty responsive :busy="isBusy"   :items="RoutesdetailsList"  
                                            :fields="Routesdetailsfields" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" class="routetable">                                            
                                        <div slot="table-busy" class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                        </div>
                                        <!-- <template slot="successfulcount" slot-scope="row">
                                            <span @click="handleColumnClick('success')">{{ row.item.successfulcount }} </span>
                                        </template> -->

                                        <template slot="successfulcount" slot-scope="row">
                                            <a href="#" @click="DownloadCSV('success',row.item.batchid)">{{ row.item.successfulcount }} </a>
                                        </template>
                                        <template slot="failurecount" slot-scope="row">
                                            <a href="#" @click="DownloadCSV('fail',row.item.batchid)">{{ row.item.failurecount }} </a>
                                        </template>
                                        <template slot="totalcount" slot-scope="row">
                                            <a href="#" @click="DownloadCSV('total',row.item.batchid)">{{ row.item.totalcount }} </a>
                                        </template>
                                        <template slot="lastmodifieddate" slot-scope="row">
                                            <div>
                                                {{ row.item.lastmodifieddate | ConvertTime12hour() }}
                                            </div>
                                        </template>
                                    </b-table>
                                    </b-col>
                                    </b-row>
                                    <b-col>
                                        <paginate 
                                            :page-count="noofpages"
                                            :page-range="10"
                                            :margin-pages="2"
                                            :click-handler="clickCallback"
                                            :prev-text="'Prev'"
                                            :next-text="'Next'"
                                            :container-class="'pagination'"
                                            :page-class="'page-item'">
                                        </paginate>
                                    </b-col>
                                    <!-- Total Records End-->
                                </b-tab>
                                
                                
                            </b-tabs>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <div id="overlay" >
                      <div class="loader"></div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
   data() {
      return {
            file1: null,
            selectcsvFile:'',
            file:'',
            selectFiletype:'',
            myToggle: false,
            RejecttotalRecord :[],
            rejectedfields: [
                { key: 'tatid', label: 'SR No.', sortable: true},
                { key: 'originpincode', label: 'Origin Pincode', sortable: true},
                { key: 'destinationpincode', label: 'Destination Pincode', sortable: true},
                // { key: 'batchid', label: 'Batch Id', sortable: true},
                { key: 'tat', label: 'TAT', sortable: true},
            ],
            acceptedRecord :[],
            acceptedfields: [
                { key: 'tatid', label: 'SR No.', sortable: true},
                { key: 'originpincode', label: 'Origin Pincode', sortable: true},
                { key: 'destinationpincode', label: 'Destination Pincode', sortable: true},
                { key: 'stringhubs', label: 'Accepted Hub', sortable: true},
            ],
            downlaodcsv :'',
            Routesdetailsfields: [
                { key: 'batchid', label: 'Batch Id', sortable: true},
                { key: 'successfulcount', label: 'Successful Count', sortable: true},
                { key: 'failurecount', label: 'Failure Count', sortable: true},
                // { key: 'batchid', label: 'Batch Id', sortable: true},
                { key: 'totalcount', label: 'Total Count', sortable: true},
                { key: 'lastmodifiedby', label: 'last modified by', sortable: true},
                { key: 'lastmodifieddate', label: 'last modified date', sortable: true},
            ],
            CountDetailsfields: [
                { key: 'successfulcount', label: 'Successful Count', sortable: true},
                { key: 'failurecount', label: 'Failure Count', sortable: true},
            ],
            totalRows :0,
            RoutesdetailsList :[],
            CountDetailsList: [],
            routertotalRows :0,
            // perPage: 20,
            // currentPage: 1,
            Usersysuser :'',
            totalrejectrow :0,
            noofpages:'',
            pageNum:1,
            listingpageno:1,
            successfulldetails:[],
            failuredetails:[]
        }
   },
   created() {
    var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.userType=userInfo.user_type;
      console.log("YYUUUU",this.userType);
      this.Usersysuser=userInfo.sysusermasterid;
      console.log("Usersysuser",this.Usersysuser)
    this.user_id = userInfo.sysusermasterid;
    this.routerDetailsdata(this.pageNum);
    const csvurl = `${CONSTANTS.MIGRATION_API_URL}/downloadRouteCSV?`
    this.downlaodcsv=csvurl;
       
   },

    methods: {
        selectcsvFiletoUpload :function (event){
            this.selectcsvFile= event.target.files[0];
            console.log("HHH",this.selectcsvFile);

            this.selectFiletype= event.target.files[0].type;
            console.log("selectFiletype",this.selectFiletype);
        },

        clearcsv :function () {
            this.file ='';
            this.CountDetailsList = [];
            // document.getElementById("successfulcard").style.display='none';

        },
        DownloadCSV :function(status,batchid)
        {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const obj={
                sysusermasterid:`${userInfo.sysusermasterid}`,
                status:`${status}`,
                batchid:`${batchid}`,
            }
          this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getTatDetailsDownload`,obj).then(result => {
                this.isBusy=false;
                if (result.body.returnmsg === "Successful") {
                    // alert("ok")
                    // this.RoutesdetailsList=result.returnvalue;
                    const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
                    const header = Object.keys(result.body.returnvalue[0]);
                    const headerlable =['Origin Pincode', 'Destination Pincode','Final Tat', 'Remark'];
                    console.log("hear------->",header);

                    let csv = result.body.returnvalue.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));

                    console.log("csv------->",csv);

                    csv.unshift(headerlable.join(','));
                    console.log("csv------->",csv);
                    csv = csv.join('\r\n');

                    //Download the file as CSV
                    var downloadLink = document.createElement("a");
                    var blob = new Blob([csv], {
                        type: 'text/csv'
                    });
                    var url = URL.createObjectURL(blob);
                    var hiddenElement = document.createElement('a');
                    hiddenElement.href = url;
                    hiddenElement.target = '_blank';
                    hiddenElement.download = status+'tatcsv';
                    hiddenElement.click();

                }else{
                    console.log("error----------->");
                    // this.RoutesdetailsList=[];
                    // this.routertotalRows=0;
                }
                }).catch(ex => {
                console.log("error", ex);
            });

                  

        },
        handleColumnClick :function(status)
        {
          if(status == 'success')
          {
            console.log("items in generateCsv-->", this.successfulldetails)
                if (this.successfulldetails.length > 0) {

                    const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
                    const header = ['originpincode', 'destinationpincode','tat','msg'];
                    const headerlable =['Origin Pincode', 'Destination Pincode','Final Tat', 'Success remark'];

                    let csv = this.successfulldetails.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
                    csv.unshift(headerlable.join(','));
                    csv = csv.join('\r\n');

                    //Download the file as CSV
                    var downloadLink = document.createElement("a");
                    var blob = new Blob([csv], {
                        type: 'text/csv'
                    });
                    var url = URL.createObjectURL(blob);
                    var hiddenElement = document.createElement('a');
                    hiddenElement.href = url;
                    hiddenElement.target = '_blank';
                    hiddenElement.download = 'tatuploadsuccessfile';
                    hiddenElement.click();
                }
          }else{

            if (this.failuredetails.length > 0) {

            const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
            const header = ['originpincode', 'destinationpincode','tat','msg'];
            const headerlable =['Origin Pincode', 'Destination Pincode','Final Tat', 'Error remark'];

            let csv = this.failuredetails.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
            csv.unshift(headerlable.join(','));
            csv = csv.join('\r\n');

            //Download the file as CSV
            var downloadLink = document.createElement("a");
            var blob = new Blob([csv], {
                type: 'text/csv'
            });
            var url = URL.createObjectURL(blob);
            var hiddenElement = document.createElement('a');
            hiddenElement.href = url;
            hiddenElement.target = '_blank';
            hiddenElement.download = 'tatuploadfailurefile';
            hiddenElement.click();
            }
         
          }

        },
        uploadcsv :function (){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            document.getElementById("overlay").style.display = "block";
            if(this.selectFiletype == 'text/csv'){

                let data = new FormData();
                            data.append('file', this.selectcsvFile)
                            data.append('createdby', `${userInfo.userfirstname}` + ' ' + `${userInfo.userlastname}`)
                            data.append('sysusermasterid', `${userInfo.sysusermasterid}`)
                        let config = {
                            header : {
                            'Content-Type' : 'multipart/form-data'
                            }
                            }
                            // console.log("Config",config);
                            // console.log("data--------->",data);
                        // return false;
                        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/uploadTatCsvPincodes`,data,{ header : {
                            'Content-Type' : 'multipart/form-data'
                            } }).then(result => {
                            // console.log("YYY",result);
                            if (result.body.returnmsg === 'Successful') {

                            this.CountDetailsList = result.body.inserpindata;
                             this.successfulldetails = result.body.successfulldetails;
                             this.failuredetails = result.body.failuredetails;
                            this.resultMsg=result.body.returnmsg;

                            // alert("inn");
                            this.$fire({
                                    text:result.body.returnvalue,
                                type: "success",
                                timer: 30000
                                }); 
                                document.getElementById("overlay").style.display = "none";
                                this.file ='';
                            this.selectcsvFile='';
                            this.selectFiletype='';
                            this.routerDetailsdata(this.pageNum);
                            }else{
                            this.file ='';
                            this.CountDetailsList = [];
                            this.$fire({
                                        text:result.body.returnvalue,
                                        type: "error",
                                        timer: 30000
                                        }); 
                                        document.getElementById("overlay").style.display = "none";
                            }
                })
                .catch(ex => {
                console.log("error", ex);
                });
            }
            else{
              document.getElementById("overlay").style.display = "none";
            this.file ='';
            this.$fire({
                        text:"Please Upload CSV File Only",
                        type: "error",
                        timer: 30000
                    }); 
            }
        },

        clickCallback (pageNum){
          this.listingpageno = pageNum;
            console.log("pageNum",this.listingpageno)
           this.routerDetailsdata(pageNum);
        },

        routerDetailsdata : function(pageNo){

            this.isBusy=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const obj={
                sysusermasterid:`${userInfo.sysusermasterid}`,
                pageno:`${pageNo}`,
            }
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getTatDetailsData`,obj).then(result => {
                    this.isBusy=false;
                    console.log("result",result)
                    if (result.body.returnmsg === "Successful") {
                        // alert("ok")
                    this.RoutesdetailsList=result.body.returnvalue;
                    console.log("RoutesdetailsList",this.RoutesdetailsList);
                    this.routertotalRows=result.body.totalcount;
                    this.noofpages=parseInt(this.routertotalRows)/100;
                    this.noofpages=Math.ceil( this.noofpages);
                    }else{
                        this.RoutesdetailsList=[];
                        this.routertotalRows=0;
                    }
                    }).catch(ex => {
                    console.log("error", ex);
                });
        }

    },
}
</script>

<style>
.routetable th, td {
    text-align: center;
}
.route-border {
    border-bottom: 1px solid #c9bebe;
    margin: 30px 0px 20px 0px;
}
</style>